import { render, staticRenderFns } from "./BrandSubscriptionHistory.vue?vue&type=template&id=77ff4119&scoped=true&"
import script from "./BrandSubscriptionHistory.vue?vue&type=script&lang=ts&"
export * from "./BrandSubscriptionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSubscriptionHistory.vue?vue&type=style&index=0&id=77ff4119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff4119",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ff4119')) {
      api.createRecord('77ff4119', component.options)
    } else {
      api.reload('77ff4119', component.options)
    }
    module.hot.accept("./BrandSubscriptionHistory.vue?vue&type=template&id=77ff4119&scoped=true&", function () {
      api.rerender('77ff4119', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/BrandSubscriptionHistory.vue"
export default component.exports